import React, { useState } from 'react';
import ImportantTermsIcon from '../../assets/pdp/importantTerms.svg';
import ArrowWithCircle from '../../assets/pdp/svgwithProps/arrowWithCircle1';
import FlexBox from '@/atomic-components/FlexBox';
import { Box, Grid } from '@mui/material';
import { LencoTypography } from '@/atomic-components/LencoTypography';
import { getStyle } from '@/utils/theme/fonts';
import { getColor } from '@/utils/theme/colors';
import ExtraFeaturesDrawerComponent from './extraFeaturesDrawer';
import FrequentlyAskedQuestions, { Detail } from './frequntlyAskedQues';
import { Inclusion } from '@/services/catalogue/models/pdp';
import CareInstructionIcon from '@/assets/pdp/svgwithProps/careInstruction1';
import CancellationAndReturnsIconFile from '@/assets/pdp/svgwithProps/cancellationAndReturns';
import WarrantyIcon from '@/assets/pdp/svgwithProps/warrantyICon1';
import QualityPerformanceIcon from '@/assets/pdp/svgwithProps/qualityIcon1';
import FAQIcon from '@/assets/pdp/svgwithProps/faq';

interface ISpecificationsAndInclusionsIconProps {
	cancellationAndReturns: any;
	careInstructions: any;
	qualityPerformance: any;
	warranty: any;
	faq: any;
	importantTerms: any;
}

type ExtraFeaturesComponentProps = {
	inclusion: Inclusion;
	faq: any;
};
const ExtraFeaturesComponent = (props: ExtraFeaturesComponentProps) => {
	const QualityAndStuffArray = [
		'cancellationAndReturns',
		'careInstructions',
		'qualityPerformance',
		'warranty',
		...(Array.isArray(props.faq) && props.faq?.length != 0 ? ['faq'] : []),
		'importantTerms',
	];

	const SpecificationsAndInclusionsIconMApper: ISpecificationsAndInclusionsIconProps =
		{
			cancellationAndReturns: {
				icon: (label: string) => {
					if (label === svgColorData)
						return <CancellationAndReturnsIconFile fill='#047992' />;
					else return <CancellationAndReturnsIconFile />;
				},
				arrowIcon: (label: string) => {
					if (label === svgColorData) return <ArrowWithCircle fill='#047992' />;
					else return <ArrowWithCircle />;
				},
				label: 'Cancellation And Returns',
			},
			careInstructions: {
				icon: (label: string) => {
					if (label === svgColorData)
						return <CareInstructionIcon fill='#047992' />;
					else return <CareInstructionIcon />;
				},
				arrowIcon: (label: string) => {
					if (label === svgColorData) return <ArrowWithCircle fill='#047992' />;
					else return <ArrowWithCircle />;
				},
				label: 'Care Instruction',
			},
			qualityPerformance: {
				icon: (label: string) => {
					if (label === svgColorData)
						return <QualityPerformanceIcon fill='#047992' />;
					else return <QualityPerformanceIcon />;
				},
				arrowIcon: (label: string) => {
					if (label === svgColorData) return <ArrowWithCircle fill='#047992' />;
					else return <ArrowWithCircle />;
				},
				label: 'Quality Performance',
			},
			warranty: {
				icon: (label: string) => {
					if (label === svgColorData) return <WarrantyIcon fill='#047992' />;
					else return <WarrantyIcon />;
				},
				arrowIcon: (label: string) => {
					if (label === svgColorData) return <ArrowWithCircle fill='#047992' />;
					else return <ArrowWithCircle />;
				},
				label: 'Warranty',
			},
			faq: {
				icon: (label: string) => {
					if (label === svgColorData) return <FAQIcon fill='#047992' />;
					else return <FAQIcon />;
				},
				arrowIcon: (label: string) => {
					if (label === svgColorData) return <ArrowWithCircle fill='#047992' />;
					else return <ArrowWithCircle />;
				},
				label: 'FAQ',
			},
			importantTerms: {
				icon: (color: string) => <CareInstructionIcon fill={color} />,
				arrowIcon: (label: string) => {
					if (label === svgColorData) return <ArrowWithCircle fill='#047992' />;
					else return <ArrowWithCircle />;
				},
				label: 'Important Terms',
			},
		};

	const [openDrawerToSeeDescription, setOpenDrawerToSeeDescription] =
		useState(false);
	const [extraFeatureData, setExtraFeatureData] = useState('');
	const [openFAQ, setOpenFAQ] = useState(false);
	const [svgColorData, setSvgColorData] = useState('');
	const { inclusion } = props;

	const openFaqsDrawer = () => {
		// if ((props?.faq as Detail[]).length > 0) {
		setOpenFAQ(true);
		// }
	};

	const handleExtraFeaturesDrawer = (data: string) => {
		data == 'faq' ? openFaqsDrawer() : setOpenDrawerToSeeDescription(true),
			setExtraFeatureData(data);
	};

	const changeSvgColor = (data: any) => {
		setSvgColorData(`${data}`);
	};

	return (
		<FlexBox direction='column' sx={{ paddingBottom: '80px' }}>
			{QualityAndStuffArray.filter((d) => {
				if (d != 'faq') {
					if (inclusion.hasOwnProperty(d)) {
						return inclusion[d as keyof Inclusion];
					}
				} else return 'faq';
			}).map((data, index) => {
				return (
					<FlexBox direction='column' key={index} sx={{ width: '95%' }}>
						{index == 0 && (
							<Box
								sx={{
									width: '100%',
									borderTop: `1px solid ${getColor('Gray -4')}`,
								}}
							></Box>
						)}
						<FlexBox
							onClick={() => handleExtraFeaturesDrawer(data)}
							sx={{
								justifyContent: 'space-between',
								width: '100%',
								padding: '20px',
								alignItems: 'center',
								cursor: 'pointer',
								color: getColor('Gray 0'),
								'&:hover': {
									background: '#FFFFFF',
									boxShadow: '0px 8px 8px rgba(34, 34, 34, 0.1)',
									color: getColor('Minty +1'),
								},
							}}
							onMouseEnter={() => {
								changeSvgColor(data);
							}}
							onMouseLeave={() => {
								changeSvgColor('');
							}}
						>
							<FlexBox>
								{SpecificationsAndInclusionsIconMApper[
									data as keyof ISpecificationsAndInclusionsIconProps
								].icon(data)}

								<LencoTypography
									sx={{
										...getStyle('P_Medium'),
										paddingLeft: '16px',
									}}
								>
									{
										SpecificationsAndInclusionsIconMApper[
											data as keyof ISpecificationsAndInclusionsIconProps
										].label
									}
								</LencoTypography>
							</FlexBox>
							<Box>
								{SpecificationsAndInclusionsIconMApper[
									data as keyof ISpecificationsAndInclusionsIconProps
								].arrowIcon(data)}
							</Box>
						</FlexBox>
						<Box
							sx={{
								width: '100%',
								borderTop: `1px solid ${getColor('Gray -4')}`,
							}}
						></Box>
					</FlexBox>
				);
			})}

			<ExtraFeaturesDrawerComponent
				openDrawerToSeeDescription={openDrawerToSeeDescription}
				setOpenExtraFeatureDrawer={() => setOpenDrawerToSeeDescription(false)}
				icon={SpecificationsAndInclusionsIconMApper[
					extraFeatureData as keyof ISpecificationsAndInclusionsIconProps
				]?.icon()}
				data={inclusion[extraFeatureData as keyof Inclusion]}
			/>

			<FrequentlyAskedQuestions
				details={props?.faq}
				isOpen={openFAQ}
				onClose={() => setOpenFAQ(false)}
			/>
		</FlexBox>
	);
};

export default ExtraFeaturesComponent;
